module.exports = __webpack_public_path__ + "img/2f_r_kokoro@2x.0806b2aa.jpg";